<template>

<div>

    <div class="title-button">

      <h1>Add Multiple Flights</h1>
      <router-link to="/flights/create" class="button">Create Flight</router-link>

    </div>

    <div class="box">

      <Errors/>

      <form class="form" v-on:submit.prevent="createFlight">

        <MultipleFlightFields/>

        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled>Creating...</button>
          </div>
          <div v-else>
            <button type="submit" class="button">Create flight</button>
          </div>
        </div>

      </form>

    </div>

</div>

</template>

<script>
import MultipleFlightFields from '@/components/MultipleFlightFields.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'MultipleFlightCreate',
  computed: mapGetters(['getLoadStatus']),
  data () {
    return {
      flight: {},
      errors: null
    }
  },
  components: {
    MultipleFlightFields,
    Errors
  },
  methods: {
    createFlight () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'flights/multiple', {
        method: 'POST',
        body: JSON.stringify(this.flight),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        console.log(response)
        this.errors = response.errors
        if(response.success) {
          this.$router.push({ name: 'flight-edit', params: { id: response.data.id }})
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
  mounted (){
  },
  }
}
</script>
